import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { GlobalBackground } from './styles/GlobalStyles';
import { motion, AnimatePresence } from 'framer-motion';
import HomePage from './home/index.jsx';
import AboutPage from './about-us/index.jsx';
import ServicesPage from './services/index.jsx';
import ProductPage from './product/index.jsx';
import BlogPage from './blog/index.jsx';
import BlogPostPage from './blog-post/index.jsx';
import ContactPage from './contact/index.jsx';
import PrivacyPolicy from './pages/policies/PrivacyPolicy.jsx';
import TermsOfService from './pages/policies/TermsOfService.jsx';
import CookiePolicy from './pages/policies/CookiePolicy.jsx';
import L33tPage from './l33t/index.jsx';
import ConsultingFlyer from './flyer/ConsultingFlyer.jsx';
import WorkflowSolutionsPage from './workflow-solutions/page.jsx';
import GovernmentLandingPage from './pages/government/index.jsx';
import PortalLayout from './pages/government/portal/PortalLayout.jsx';
import WhatIsTransmediaIP from './pages/product/WhatIsTransmediaIP.jsx';
import PlatformOverview from './pages/product/PlatformOverview.jsx';
import AIReadinessAssessment from './services/AIReadinessAssessment.jsx';
import AIAssessmentForm from './services/AIAssessmentForm.jsx';
import { MainNavbar } from './shared/components/MainNavbar';
import ChatWidget from './shared/components/ChatWidget';

function App() {
  return (
    <HelmetProvider>
      <Router>
        {/* Global background with gradients and patterns */}
        <GlobalBackground />
      
      {/* Main content */}
      <Routes>
        {/* Flyer route without navigation and chat widget */}
        <Route path="/flyer" element={<ConsultingFlyer />} />
        
        {/* Regular routes with navigation and chat widget */}
        <Route path="/" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <HomePage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/about" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <AboutPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/services" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <ServicesPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/services/ai-readiness-assessment" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <AIReadinessAssessment />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/services/ai-assessment-form" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <AIAssessmentForm />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/product" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <ProductPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/product/platform-overview" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <PlatformOverview />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/product/what-is-transmedia-ip" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <WhatIsTransmediaIP />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/gov" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <GovernmentLandingPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/gov/portal/:clientId" element={<PortalLayout />} />
        <Route path="/blog" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <BlogPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/blog/:slug" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <BlogPostPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/contact" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <ContactPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/privacy-policy" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <PrivacyPolicy />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/terms-of-service" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <TermsOfService />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/cookie-policy" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <CookiePolicy />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/l33t" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <L33tPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
        <Route path="/workflow-solutions" element={
          <div className="relative min-h-screen text-gray-100">
            <MainNavbar />
            <AnimatePresence mode="wait">
              <WorkflowSolutionsPage />
            </AnimatePresence>
            <ChatWidget />
          </div>
        } />
      </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
